import { HttpWrapper } from '@/shared/services/rest.service';
import * as endpoints from './endpoints';

export default {
    getOrderTasksByOrder(orderUniqueId) {
        return HttpWrapper.get(`${endpoints.ORDER}/${orderUniqueId}/OrderTasks`);
    },
    getOrderTaskParties(orderUniqueId, snuTaskIds) {
        return HttpWrapper.post(`${endpoints.ORDER}/${orderUniqueId}/OrderTaskNotificationParties`, snuTaskIds);
    },
    markOrderTaskComplete(orderUniqueId, snuTaskId, parties) {
        return HttpWrapper.put(`${endpoints.ORDER}/${orderUniqueId}/OrderTask/${snuTaskId}/MarkComplete`, parties);
    },
    removeCompleteStatus(orderUniqueId, snuTaskId) {
        return HttpWrapper.put(`${endpoints.ORDER}/${orderUniqueId}/OrderTask/${snuTaskId}/MarkIncomplete`);
    },
    saveOrderTaskNotificationSettings(orderUniqueId, notificationSettings) {
        return HttpWrapper.post(`${endpoints.ORDER}/${orderUniqueId}/OrderTask/NotificationSettings`, notificationSettings);
    }
}